export const todoMainConstants = {
  LANES_VIEW: 'LANES_VIEW',
  BOARDS_VIEW: 'BOARDS_VIEW',

  HANDEL_SET_VIEW: 'HANDEL_SET_VIEW',
  HANDEL_SET_EDIT: 'HANDEL_SET_EDIT',
  HANDEL_SET_FORM: 'HANDEL_SET_FORM',

  HANDLE_LANE_FORM: 'HANDLE_LANE_FORM',
  HANDLE_TODO_FORM: 'HANDLE_TODO_FORM',
  HANDLE_BOARD_FORM: 'HANDLE_BOARD_FORM',
  HANDLE_INPUT_CHANGE: 'HANDLE_INPUT_CHANGE',

  HANDEL_SET_LANE: 'HANDEL_SET_LANE',
};
